
import Typography from '@mui/material/Typography';


export const TextDrugAtomoxetine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Atomoxetine is used as part of a total treatment program to increase the ability to pay attention and decrease impulsiveness and hyperactivity in 
children and adults with ADHD. Atomoxetine is in a class of medications called selective norepinephrine reuptake inhibitors. 
It works by increasing the levels of norepinephrine, a natural substance in the brain that is needed to control behavior.
<br /><br />


Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a603013.html

</Typography>

</div>

)
}